//@ts-check
// @ts-ignore
import Login from './login.riot';
import { loginRequest, loginSuccess, loginFailure } from './login.action';
import { getURLParameters } from '@/common/utils';
import { ajaxPost } from '../ajax';
import { connect } from '@/common/lib/riot-redux';
import storage from '@/common/storage';
import { openInfoDialog } from '@/common/components/kf-dialog';
import { SERVER_LIST } from '@/common/constants';
import { getApiEntry } from '@/common/utils/server';


const mapDispatchToProps = (dispatch) => ({
  async login(payload) {
    dispatch(loginRequest());
    const { mail, password, saveInputCheck } = payload;
    try {
      const data = await ajaxPost('/login', { 
        method: 'login', 
        mail, 
        password 
      });
      if (saveInputCheck) {
        storage.setItem('saveInputCheck', '1');
        storage.setItem('mail', mail);
        storage.setItem('password', password);
      } else {
        storage.setItem('saveInputCheck', '0');
        storage.removeItem('mail');
        storage.removeItem('password');
      }

      const redirectUrl = getURLParameters(location.href).redirect;
      if (data.isAdmin) {
        // fetch from other servers
        for (const server in SERVER_LIST) {
          try {
            // login simultaneously to all available servers
            await ajaxPost('/login', {
              method: 'login', 
              mail, 
              password,
            }, getApiEntry(server));
          } catch (e) {
            // do nothing if failed
            console.log(server, e);
          }
        }
        // navigate
        location.href = '/admin';
      } else if (redirectUrl) {
        location.href = decodeURIComponent(redirectUrl);
        storage.setOwnerLogin(mail);
      } else {
        location.href = '/owner/#';
        storage.setOwnerLogin(mail);
      }
      dispatch(loginSuccess(data));
    } catch (e) {
      dispatch(loginFailure(e));
    }
  },

  openInfoDialog(message) {
    dispatch(openInfoDialog(message));
  }
});

export default connect(Login, null, mapDispatchToProps);